import React, { useState, cloneElement, useEffect, useRef } from 'react';
import { FaCity, FaDatabase, FaMinus, FaPlus, FaBullhorn, FaEnvelope, FaPalette, FaCertificate, FaChartLine, FaRegObjectGroup } from 'react-icons/fa6';
import { TbCertificate } from "react-icons/tb";
import DropDown from './customDropDown';
import { FaTrash, FaUserCheck } from 'react-icons/fa';

const ICONS = {
    FaCity: FaCity,
    FaDatabase: FaDatabase,
    FaBullhorn: FaBullhorn,
    FaEnvelope: FaEnvelope,
    FaPalette: FaPalette,
    TbCertificate: TbCertificate,
    FaChartLine: FaChartLine,
    FaRegObjectGroup: FaRegObjectGroup,
    FaUserCheck: FaUserCheck
};



const CustomTabs = ({ children, addTab, setNewTab, langTabs, remove, text, setDefaultTab, onTabClick }) => {
    const [activeTab, setActiveTab] = useState(0);
    const [showDropdown, setShowDropdown] = useState(false);
    const [rteLanguages, setRteLanguages] = useState([]);
    const [newTabAdded, setNewTabAdded] = useState(false);
    const containerRef = useRef(null);

    const defaultRteLanguages = [
        { label: "Catalá", value: "ca" },
        { label: "Euskara", value: "eu" },
        { label: "English", value: "en" },
        { label: "Italiano", value: "it" },
    ];

    useEffect(() => {
        if (langTabs) {
            // Filtrar idiomas que aún no están en langTabs

            const availableLanguages = defaultRteLanguages.filter(language =>
                !langTabs.some(tab => tab.language === language.value)
            );
            setRteLanguages(availableLanguages);
        } else {
            // Si langTabs es undefined, establece rteLanguages a defaultRteLanguages
            setRteLanguages(defaultRteLanguages);
        }
    }, [langTabs]);

    useEffect(() => {
        setActiveTab(0)
    }, [setDefaultTab]);


    const toggleDropdown = () => {

        setShowDropdown(!showDropdown);
    }


    useEffect(() => {
        if (newTabAdded) {
            toggleDropdown()
            setActiveTab(React.Children.count(children) - 1);
            setNewTabAdded(false);
        }
    }, [children, newTabAdded]);

    const handleSelectedValue = (value) => {
        if (addTab) {
            setNewTab(value)
            setNewTabAdded(true);
        }
    }

    const handleRemove = (e, id) => {
        e.stopPropagation();
        remove(id)
    }



    return (
        <div>
            <div className="custom-tabs-container">
                {React.Children.map(children, (child, index) => {
                    const IconComponent = ICONS[child.props.icon];

                    return (
                        <div
                            key={index}
                            onClick={() => { setActiveTab(index); { onTabClick && child.props.id && onTabClick(child.props.id) } }}
                            className={`custom-tab font-bold ${index === activeTab ? 'custom-tab-active ' : ''}`}
                        >
                            {IconComponent && <IconComponent size={18} className='me-1' />}
                            <span className='width-95 text-center'>{child.props.title}</span>
                            {child.props.removable &&
                                <div className={`custom-tab-trashcan-container custom-shadow ${index === activeTab && 'custom-tab-trashcan-container-active '}`}>
                                    <FaTrash size={13}
                                        className={`custom-tab-trashcan-icon ${index === activeTab && 'custom-tab-trashcan-icon-active '}`}
                                        onClick={(e) => handleRemove(e, child.props.id)}
                                    />
                                </div>
                            }

                        </div>
                    );
                })}
                {addTab && rteLanguages.length > 0 &&

                    <>
                        <div
                            ref={containerRef}
                            onClick={toggleDropdown}
                            className={`custom-tab font-bold custom-tab-add`}
                        >
                            <FaPlus size={18} className='ms-1 me-1' />
                        </div>
                        {showDropdown &&
                            <DropDown
                                options={rteLanguages}
                                opened={true}
                                onChange={handleSelectedValue}
                            />
                        }

                    </>
                }
                {
                    text &&
                    <span className='custom-tab-warning-message'>{text}</span>
                }




            </div>
            <div className='custom-tab-underline' />
            <div className="tab-content">
                {React.Children.map(children, (child, index) =>
                    cloneElement(child, { isActive: index === activeTab })
                )}
            </div>
        </div>
    );
};

export const CustomTab = ({ isActive, children }) => {
    if (!isActive) return null;

    return <div>{children}</div>;
};

export default CustomTabs;
